/**
 * Where an avatar actually lives, from the path the profile stores.
 *
 * The storage service has no public hostname — the gateway is the only public
 * door — so pictures come back through the same-origin proxy, which attaches
 * the gateway key server-side. That is why this is a function and not a
 * template literal at each call site: the day the path changes, it changes
 * once.
 */
export function avatarUrl(path?: string | null): string | undefined {
  const clean = (path ?? '').trim().replace(/^\/+/, '')
  if (!clean) return undefined
  // Anything that is not one of our stored paths is ignored rather than
  // rendered: a profile row is user input, and an <img src> is a request this
  // page makes on the viewer's behalf.
  if (!/^avatars\/[A-Za-z0-9._-]+$/.test(clean)) return undefined
  return `/api/storage/${clean}`
}
